<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{ t('assignmentTypes') }}</h2>
<kendo-grid
  [data]="assignmentTypes"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>

  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-formfield>
        <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('required') || formGroup.get('name').hasError('pattern')">{{ t('isRequiredField') }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('maxlength')">{{ t('nameTooLong', { max: 75 }) }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('isNotUnique')">{{ t('nameMustBeUnique') }}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isActive" [title]="t('active')" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.isActive ? t('yes') : t('no') }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <input
        type="checkbox"
        kendoCheckBox
        [value]="dataItem.isActive"
        [formControl]="formGroup.get('isActive')"
      />
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="sortOrder" [title]="t('order')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <!-- Backend expects an int: no decimals allowed. -->
      <kendo-numerictextbox
        [decimals]="0"
        [format]="'n0'"
        [formControl]="formGroup.get('sortOrder')"
      ></kendo-numerictextbox>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column [title]="t('action')">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.assignmentType')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
